module.exports = __webpack_public_path__ + "static/img/index3(1)_07.4193152.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index3(1)_07.png
// module id = 3126
// module chunks = 1